import { inject, Injectable } from '@angular/core';
import type { FormArray, FormControl } from '@angular/forms';

import { AssignLocationsFacade } from '@core/locations-legacy';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class AssignLocationsRequisitionFacade extends AssignLocationsFacade {
  private readonly requisitionFormManager = inject(RequisitionFormManagerService);

  public validateLocations: undefined;
  public getNewLocationOptions: undefined;

  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
